// Lógica pura de cada fila de la pestaña «aforo»: valores editables, qué ha cambiado, avisos
// y cuerpo de `PATCH /admin/funciones/:id`. Sin React, para poder probarla aislada.

/** Campos numéricos editables, con su etiqueta corta (cabecera) y la completa (accesible). */
export const CAMPOS_AFORO = [
  { campo: 'aforo', corta: 'Aforo', completa: 'Aforo total' },
  { campo: 'portales', corta: 'Portales', completa: 'Ventas realizadas en portales' },
  { campo: 'reservas', corta: 'Reservas', completa: 'Reservas manuales' },
];

/**
 * Valores del formulario a partir de la función. Los números se guardan como texto para que el
 * campo pueda quedar vacío mientras se escribe (antes, `Number('')` lo convertía en 0 al instante).
 */
export const valoresIniciales = f => ({
  ...Object.fromEntries(CAMPOS_AFORO.map(({ campo }) => [campo, f[campo] === undefined || f[campo] === null ? '' : String(f[campo])])),
  cerrada: !!f.cerrada, motivo: '', resolverIncidencia: false,
});

const siNo = valor => (valor ? 'sí' : 'no');

/** Lista de cambios respecto a la función: `[{ campo, etiqueta, antes, despues }]`. Vacía si no hay ninguno. */
export function cambiosAforo(f, valores) {
  const cambios = CAMPOS_AFORO
    .filter(({ campo }) => valores[campo] === '' || Number(valores[campo]) !== f[campo])
    .map(({ campo, corta }) => ({ campo, etiqueta: corta, antes: String(f[campo] ?? ''), despues: valores[campo] === '' ? 'vacío' : String(Number(valores[campo])) }));
  if (valores.cerrada !== !!f.cerrada) cambios.push({ campo: 'cerrada', etiqueta: 'Cerrar venta', antes: siNo(f.cerrada), despues: siNo(valores.cerrada) });
  if (valores.resolverIncidencia) cambios.push({ campo: 'resolverIncidencia', etiqueta: 'Resolver incidencia', antes: 'no', despues: 'sí' });
  return cambios;
}

/** «Aforo 100 → 90 · Cerrar venta no → sí». */
export const describirCambios = cambios => cambios.map(c => `${c.etiqueta} ${c.antes} → ${c.despues}`).join(' · ');

/** Cuerpo del PATCH, con las mismas claves que antes de compactar la pestaña. */
export const cuerpoAjuste = (f, valores) => ({
  aforo: Number(valores.aforo), portales: Number(valores.portales), reservas: Number(valores.reservas),
  cerrada: valores.cerrada, motivo: valores.motivo, resolverIncidencia: valores.resolverIncidencia, version: f.version,
});

/** Avisos de la función: etiqueta corta para la fila y texto completo para el desplegable. */
export function avisosFuncion(f) {
  const avisos = [];
  if (f.exceso) avisos.push({ tipo: 'exceso', etiqueta: `Exceso ${f.exceso}`, texto: `Exceso de aforo: ${f.exceso}. Nuevas ventas web bloqueadas.` });
  if (f.incidencia) avisos.push({ tipo: 'incidencia', etiqueta: 'Incidencia', texto: f.incidencia });
  return avisos;
}
